/**
 * Stats > Aggregate — hardcoded MVP catalogs shared between AggReportView.tsx (renders/runs a
 * saved report) and AggReportSetupView.tsx (lets an admin pick from these when building one).
 * No generic filter-type builder for this MVP — a report's Filters just reference these fixed
 * catalog keys (see StatsAggFilterDefDto).
 */

export interface AggFilterCatalogEntry {
  /** Catalog key — what a saved report's StatsAggFilterDefDto.Name/the runtime
   * StatsFilterDto.Name is set to. */
  name: string;
  /** Display label used in both the Setup screen's filter picker and — for 'site' — nowhere
   * else ('period'/'previous' render their own labels via periodFilterOptions.ts). */
  dName: string;
}

export const AGG_FILTER_CATALOG: AggFilterCatalogEntry[] = [
  { name: 'site', dName: 'Site' },
  { name: 'startDate', dName: 'Start Date' },
  { name: 'endDate', dName: 'End Date' },
];

/** A Site value of '0' means online admins (not tied to a physical site) — displayed and
 * offered as this label wherever a site is shown in the Stats views. */
export const ONLINE_SITE_VALUE = '0';
export const ONLINE_SITE_LABEL = 'Online';

export interface AggItemTypeOption {
  value: string;
  label: string;
  /** Whether this item type's "Group By" (VarY) dropdown is shown/required in Setup. */
  needsVarY: boolean;
}

export const AGG_ITEM_TYPE_OPTIONS: AggItemTypeOption[] = [
  { value: 'Frequency', label: 'Frequency Table', needsVarY: false },
  { value: 'CrossTab', label: 'Cross-Tabulation', needsVarY: true },
  { value: 'Bar', label: 'Bar Graph', needsVarY: false },
  { value: 'Line', label: 'Line Graph', needsVarY: true },
];
